var $ = require('../internals/export');

var parseIntImplementation = require('../internals/number-parse-int'); // `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix


$({
  global: true,
  forced: parseInt != parseIntImplementation
}, {
  parseInt: parseIntImplementation
});